import { Action } from 'redux';
import {
    LandingCheckout,
    LandingCheckoutStatusEnum,
    LandingPage,
    SimpleLandingCheckout,
    Template,
} from '@dev/ee-api/ee-api-models';
import { GetCheckoutsParams } from '@/services/ApiCategories/checkouts';

export type CheckoutsListItem = SimpleLandingCheckout & { 
    isChangingStatus?: boolean
};
export interface CheckoutListState {
    loadingTemplates?: boolean;
    loadingTemplate?: boolean;
    templatesList?: CheckoutsListItem[];
    count?: number;
    UpdatingTemplate?: boolean;
    DeletingTemplate?: boolean;
    previewLoading?: boolean;
    templateSaving?: boolean;
    name?: string;
    template?: SimpleLandingCheckout;
    templateObject?: SimpleLandingCheckout;
    checkout?: LandingCheckout;
    checkedCheckouts?: string[];
    ispublic?: boolean;
    removeScreenshot?: boolean;
    prevTemplateName?: string;
    changes?: Template;
    publishedCount?: number;
    unpublishedCount?: number;
}

export interface StdLoadListInterface extends GetCheckoutsParams, GetCheckoutsParams {
    isUrlUpdateDisabled?: boolean
}

export interface UrlSearchParams {
    page?: number;
    perPage?: number;
    search?: string;
    from?: string;
    to?: string;
    status?: [];
}

export enum CheckoutsActionTypes {
    GET_ALL_CHECKOUTS_START = '@@checkouts/GET_ALL_CHECKOUTS_START',
    GET_ALL_CHECKOUTS_SUCCESS = '@@checkouts/GET_ALL_CHECKOUTS_SUCCESS',
    GET_ALL_CHECKOUTS_ERROR = '@@checkouts/GET_ALL_CHECKOUTS_ERROR',
    GET_CHECKOUT_BY_NAME_START = '@@checkouts/GET_CHECKOUT_BY_NAME_START',
    GET_CHECKOUT_BY_NAME_SUCCESS = '@@checkouts/GET_CHECKOUT_BY_NAME_SUCCESS',
    GET_CHECKOUT_BY_NAME_ERROR = '@@checkouts/GET_CHECKOUT_BY_NAME_ERROR',
    DELETE_CHECKOUTS = '@@checkouts/DELETE_CHECKOUTS',
    DELETE_CHECKOUTS_SUCCESS = '@@checkouts/DELETE_CHECKOUTS_SUCCESS',
    DELETE_CHECKOUTS_ERROR = '@@checkouts/DELETE_CHECKOUTS_ERROR',
    PICK_CHECKOUTS = '@@checkouts/PICK_CHECKOUTS',
    UNPICK_CHECKOUTS = '@@checkouts/UNPICK_CHECKOUTS',
    LOAD_PREVIEW_TEMPLATE = '@@checkouts/LOAD_PREVIEW_TEMPLATE',
    LOAD_PREVIEW_TEMPLATE_SUCCESS = '@@checkouts/LOAD_PREVIEW_TEMPLATE_SUCCESS',
    LOAD_PREVIEW_TEMPLATE_ERROR = '@@checkouts/LOAD_PREVIEW_TEMPLATE_ERROR',
    CLEAR_PREVIEW_TEMPLATE = '@@checkouts/CLEAR_PREVIEW_TEMPLATE',
    UPDATE_CHECKOUT_STATUS ='@@checkouts/UPDATE_CHECKOUT_STATUS',
    UPDATE_CHECKOUT_STATUS_SUCCESS = '@@checkouts/UPDATE_CHECKOUT_STATUS_SUCCESS',
    UPDATE_CHECKOUT_STATUS_ERROR = '@@checkouts/UPDATE_CHECKOUT_STATUS_ERROR'
}

export interface GetAllCheckoutsStartAction extends Action {
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_START;
    payload: StdLoadListInterface;
}

export interface GetAllCheckoutsSuccessAction extends Action {
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_SUCCESS;
    payload: StdLoadListInterface;
}

export interface GetAllCheckoutsErrorAction extends Action {
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_ERROR;
    payload: StdLoadListInterface;
}

export interface DeleteCheckoutAction extends Action {
    type: CheckoutsActionTypes.DELETE_CHECKOUTS;
    payload: {
        Names: string[];
        UrlParams: StdLoadListInterface;
    };
}

export interface DeleteCheckoutSuccessAction extends Action {
    type: CheckoutsActionTypes.DELETE_CHECKOUTS_SUCCESS;
}
export interface DeleteCheckoutErrorAction extends Action {
    type: CheckoutsActionTypes.DELETE_CHECKOUTS_ERROR;
}
export interface PickCheckoutsAction extends Action {
    type: CheckoutsActionTypes.PICK_CHECKOUTS;
    payload: {
        checkedCheckouts: string[];
    };
}
export interface UnpickAllCheckoutsAction extends Action {
    type: CheckoutsActionTypes.UNPICK_CHECKOUTS;
}

export interface GetCheckoutByNameStartAction extends Action {
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_START;
    payload: { name: string; isTemplateThumbnailsRequired?: boolean };
}

export interface GetCheckoutByNameSuccessAction extends Action {
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_SUCCESS;
    payload: {
        singleCheckout: LandingPage;
    };
}

export interface GetCheckoutByNameErrorAction extends Action {
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_ERROR;
}

export interface LoadPreviewTemplateAction extends Action {
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE;
    payload: {
        name: string;
        previewLoading: boolean;
    };
}

export interface LoadPreviewTemplateSuccessAction extends Action {
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS;
    payload: {
        checkout: LandingCheckout;
        previewLoading: boolean;
    }
}

export interface LoadPreviewTemplateErrorAction extends Action {
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_ERROR;
    payload: {
        previewLoading: boolean;
    }
}

export interface ClearPreviewTemplateAction extends Action {
    type: CheckoutsActionTypes.CLEAR_PREVIEW_TEMPLATE;
    payload: null;
}

export interface UpdateCheckoutStatusStartAction extends Action {
    type: CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS;
    payload: {
        name: string;
        status: LandingCheckoutStatusEnum;
    }
}
export interface UpdateCheckoutStatusSuccessAction extends Action {
    type: CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_SUCCESS;
    payload: {
        status: LandingCheckoutStatusEnum;
        name: string;
    }
}
export interface UpdateCheckoutStatusErrorAction extends Action {
    type: CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_ERROR;
    payload: {
        name: string;
    }
}


export enum DropdownOptions {
    EditCheckout = 'edit',
    CheckoutLink = 'link',
    Delete = 'delete',
}
